import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "lpu-doctor-card-header d-flex flex-column align-center position-relative",
      class: [_setup.isMobile ? "lpu-doctor-card-header--full" : "", "ga-3"],
    },
    [
      _vm.doctor.is_exists_video_card || _vm.doctor.is_case_exists
        ? _c(
            "div",
            {
              staticClass:
                "lpu-doctor-card-header__anchor-links d-flex flex-column ga-2",
              class: {
                "lpu-doctor-card-header__anchor-links--card-edge":
                  _setup.isMobile,
              },
            },
            [
              _vm.doctor.is_case_exists
                ? _c(
                    VTooltip,
                    {
                      attrs: {
                        left: !_setup.isMobile,
                        right: _setup.isMobile,
                        "open-on-hover": "",
                        "open-on-click": false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "a",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "d-flex",
                                        attrs: {
                                          href: `${_vm.doctorPageUrl}#cases`,
                                        },
                                      },
                                      "a",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("img", {
                                      attrs: {
                                        width: "32",
                                        height: "32",
                                        src: "/static/_v1/pd/icons/ui-kit/doctor-cases.svg",
                                        alt: _setup.tStatic(
                                          "Иконка - кейсы врача"
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2992663873
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-caption text-no-wrap bg-gray-0--text",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.tStatic("Примеры работ")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.doctor.is_exists_video_card
                ? _c(
                    VTooltip,
                    {
                      attrs: {
                        left: !_setup.isMobile,
                        right: _setup.isMobile,
                        "open-on-hover": "",
                        "open-on-click": false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "a",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "d-flex",
                                        attrs: {
                                          href: `${_vm.doctorPageUrl}#video-card`,
                                        },
                                      },
                                      "a",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("img", {
                                      attrs: {
                                        width: "32",
                                        height: "32",
                                        src: "/static/_v1/pd/icons/ui-kit/video-card-play.svg",
                                        alt: _setup.tStatic(
                                          "Иконка - видео-визитка врача"
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3719197005
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-caption text-no-wrap bg-gray-0--text",
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.tStatic("Видеовизитка")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lpu-doctor-card-header__avatar-wrap flex-shrink-0" },
        [
          _c(
            "a",
            {
              staticClass: "d-block text-decoration-none",
              attrs: { href: _vm.doctorPageUrl },
            },
            [
              _c("img", {
                staticClass: "lpu-doctor-card-header__avatar",
                attrs: {
                  src: _setup.avatarUrl,
                  alt: _setup.doctorName,
                  "data-image-refresh-selector": String(_vm.doctor.id),
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _setup.context.request.feature_flags.ff_redesign_rating && _setup.stars
        ? _c(
            "div",
            { staticClass: "doctor-card-rating-v2 w-100" },
            [
              _c(_setup.RatingRow, {
                attrs: {
                  solidity: _setup.stars,
                  "reviews-count": _setup.ratesCount,
                  "reviews-href": `${_vm.doctorPageUrl}#otzivi`,
                  centered: "",
                },
              }),
            ],
            1
          )
        : _setup.stars
        ? [
            _c(
              "div",
              {
                staticClass:
                  "lpu-doctor-card-header__rating d-flex align-center justify-center pa-3 rounded-20 border-sm bg-gray-0",
              },
              [_c(_setup.StarsRate, { attrs: { solidity: _setup.stars } })],
              1
            ),
            _vm._v(" "),
            _setup.ratesCount
              ? _c(
                  "a",
                  {
                    staticClass:
                      "text-body-2 link-decoration-underline text-secondary--text",
                    attrs: { href: `${_vm.doctorPageUrl}#otzivi` },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.ratesCount) +
                        " " +
                        _vm._s(_setup.tStatic(_setup.reviewNoun)) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _setup.isStaff && !_setup.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "lpu-doctor-card-header__staff d-flex flex-column align-center ga-1 mt-2",
            },
            [
              _c(
                _setup.DoctorAvatarEditor,
                {
                  attrs: {
                    "doctor-id": _vm.doctor.id,
                    "image-selector": `[data-image-refresh-selector='${_vm.doctor.id}']`,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "lpu-doctor-card-header__staff-btn text-body-2",
                      attrs: {
                        type: "button",
                        "data-qa": "lpu_doctors_list_staff_avatar",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tStatic("Аватар")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "lpu-doctor-card-header__staff-btn text-body-2",
                  attrs: {
                    type: "button",
                    "data-qa": "lpu_doctors_list_staff_education",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.openStaffDoctorEditDialog(
                        _setup.staffEditUrl,
                        "doctoredit_education"
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Образование")) +
                      " (" +
                      _vm._s(_vm.doctor.educations_count || 0) +
                      ")\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "lpu-doctor-card-header__staff-btn text-body-2",
                  attrs: {
                    type: "button",
                    "data-qa": "lpu_doctors_list_staff_job",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.openStaffDoctorEditDialog(
                        _setup.staffEditUrl,
                        "doctoredit_job"
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Опыт работы")) +
                      " (" +
                      _vm._s(_vm.doctor.jobs_count || 0) +
                      ")\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "lpu-doctor-card-header__staff-btn text-body-2",
                  attrs: {
                    type: "button",
                    "data-qa": "lpu_doctors_list_staff_course",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.openStaffDoctorEditDialog(
                        _setup.staffEditUrl,
                        "doctoredit_course"
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Курсы")) +
                      " (" +
                      _vm._s(_vm.doctor.courses_count || 0) +
                      ")\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }